
<template>
  <div>
    <!--START FOOTER-->
    <!-- <footer class="footer" v-if="!show">
      <div class="container">
        <div class="flx-align">
          <div class="">
            <h4>美通供应链</h4>
            <div class="" style="margin-top: 27px;">
              <ul class="list-unstyled footer-list">
                <li>
                  <i class="label">深圳总部：</i><i class="content">深圳市龙岗区坂田五和大道南路49号金方华电商产业园9栋105 / 深圳市龙岗区雅园路26号坂银谷A1001-A1004</i>
                </li>
                <li>
                  <i class="label">机场分部：</i><i class="content">深圳市宝安区福永街道怀德国际大厦1501-02</i>
                </li>
                <li>
                  <i class="label">观澜分部：</i><i class="content">深圳市龙华区观澜街道牛湖社区观天路17号大地城红木市场</i>
                </li>
     
              </ul>
            </div>
          </div >
          <div :span="6"  class="flx-center">
            <img style="margin-right: 53px;" src="@/assets/images/footer/qrcode1.png" alt="">
            <img src="@/assets/images/footer/qrcode2.png" alt="">
          </div >
        
        </div>
      </div>
    </footer> -->
   
     <footer class="footer" >
      <div class="container">
        <div class="flx-justify-around" style="margin-top: 72px;padding: 0 140px;">
          <div>
            <img  style=" width:135px;height: 135px;" :src="$ossUrl+'images/platform/publicAccount.png'" alt="">
            <div style="text-align:center;font-size: 16px;color: #fff;font-weight: 500;margin-top:17px">美通公众号</div>
          </div>
          <div>
            <img  style=" width:135px;height: 135px;" :src="$ossUrl+'images/platform/videoQrcode.png'" alt="">
            <div style="text-align:center;font-size: 16px;color: #fff;font-weight: 500;margin-top:17px">美通视频号</div>
          </div>
          <div >
            <img style=" width: 135px;height: 135px;" :src="$ossUrl+'images/platform/tiktokQrcode.png'" alt="">
            <div style="text-align:center;font-size: 16px;color: #fff;font-weight: 500;margin-top:17px">美通抖音号</div>
          </div>
          <div>
            <img style=" width:135px;height: 135px;" :src="$ossUrl+'images/platform/redBook.png'" alt="">
            <div style="text-align:center;font-size: 16px;color: #fff;font-weight: 500;margin-top:17px">美通小红书</div>
          </div>
        </div>
      </div>
    </footer>
    <!--END FOOTER-->

    <!--START FOOTER ALTER-->
    <div class="footer-alt">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="pull-none flx-center">
              <p
                class="copy-rights text-muted mb-3 mb-sm-0"
              >Copyright 2022 ©深圳市美通供应链有限公司 ALL Rights Reserved    粤ICP备<a href="https://beian.miit.gov.cn" target="_blank">2021045320</a>号</p>

            </div>
          
           
          </div>
        </div>
      </div>
    </div>
    <!--START FOOTER ALTER-->
  </div>
</template>
<script>
/**
 * Footer component
 */
export default {
  name: 'Footer',
  data(){
    return {
      show:false
    }
  },
  watch: {
      '$route'(to, from) {
        // 路由变化时调用
        if(to.path ==='/about') {
          this.show = true;
        }else {
          this.show = false;
        }
        // 你可以在这里执行相关的逻辑
      }
    }
}
</script>
<style scoped>
@import './styles/footer.css';
</style>
